<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else 
                 class="m-0 p-0" 
                 style="max-width: 100%">

        <b-container  class="m-0 filter-trade-point-container">

            <b-row class="filter-trade-point-row">

                <b-col cols="3" class="p-0">

                    <b-row id="navigation-by-view-TT" class="m-0 ">

                        <b-col cols="1" class="p-0">
                            <span class="cursor-pointer" @click="openAudit">
                                <font-awesome-icon icon="arrow-left" class="icon-back"/>
                            </span>
                        </b-col>

                        <b-col class="filter-trade-point-col">
                            <b-button-group>
                                <b-button id="btn-view-list"
                                          class="filter-trade-point-view-button" 
                                          :class="isViewMap ?  '' : 'check'" 
                                          @click="setViewMap('list')">
                                        Список
                                </b-button>
                                <b-button id="btn-view-map"
                                          class="filter-trade-point-view-button"
                                          :class="isViewMap ?  'check' : ''" 
                                          @click="setViewMap('map')">
                                        Карта
                                </b-button>
                            </b-button-group>
                        </b-col>

                    </b-row>      
                    
                </b-col>

                <transition name="search"
                            enter-active-class="animated fadeInRight"
                            leave-class="animated fadeOutRight">

                    <b-col v-if="isShowSearchInput">

                        <b-row class="filter-trade-point-search-row">
                            <b-col class="filter-trade-point-search-col">
                                <b-input-group>
                                    <b-input-group-prepend class="filter-trade-point-search-background-icon">
                                        <font-awesome-icon icon="search" class="filter-trade-point-search-icon"/>
                                    </b-input-group-prepend>

                                    <b-input v-model="searchText"
                                             placeholder="Нажмите enter для поиска"
                                             @keyup.enter="searchByName"
                                             class="filter-trade-point-search-input"/>

                                </b-input-group>   
                            </b-col>
                            
                            <b-col cols="1"
                                   class="filter-trade-point-col"
                                   @click="hideSearchInput">
                                
                                <span id="filter-trade-point-search-cancel" class="text">
                                    Отменить
                                </span>                            
                            </b-col>

                        </b-row>
                    </b-col>
                
                </transition>

                <transition name="filter"
                        enter-active-class="animated fadeInRight"
                        leave-class="animated fadeOutRight">

                    <b-col v-if="!isShowSearchInput">
                        <b-row>
                            <b-col v-if="entity.Employees.length" class="m-0 p-2px">

                                <b-button block 
                                          id="btn-filter"
                                          class="text filter-trade-point-button"
                                          :class="entity.isEmployees() ? 'active' : ''" 
                                          @click="clickFilter('Filters')">

                                    <font-awesome-icon icon="sliders-h"/>
                                    Фильтры
                                </b-button>
                            </b-col>

                            <b-col class="m-0 p-2px">

                                <b-button block
                                          id="btn-all"
                                          class="text filter-trade-point-button"
                                          :class="entity.DisplayTT == 1 ? 'active' : ''"
                                          @click="clickFilter('All')">

                                    <font-awesome-icon icon="store-alt" />
                                    Все ТТ
                                </b-button>
                            </b-col>

                            <b-col class="m-0 p-2px">
                                <b-button block
                                          id="btn-search" 
                                          class="text filter-trade-point-button" 
                                          @click="isShowSearchInput = !isShowSearchInput">

                                    <font-awesome-icon icon="search" />
                                    Поиск ТТ
                                </b-button>
                            </b-col>

                            <b-col v-if="isTradePointsExist" class="m-0 p-2px">
                                <b-button block
                                          id="btn-my"
                                          class="text filter-trade-point-button" 
                                          :class="entity.DisplayTT == 5 ? 'active' : ''"
                                          @click="clickFilter('My')">

                                    <font-awesome-icon icon="folder-open" />
                                    Мои ТТ
                                </b-button>
                            </b-col>

                            <b-col v-if="isRouteExist" class="m-0 p-2px">
                                <b-button block
                                          id="btn-route"
                                          class="text filter-trade-point-button" 
                                          :class="entity.DisplayTT == 4 ? 'active' : ''"
                                          @click="clickFilter('MyRoutes')">

                                    <font-awesome-icon icon="route" />
                                    Мой маршрут
                                </b-button>
                            </b-col>

                            <b-col class="m-0 p-2px">
                                <b-button block 
                                          id="btn-create"
                                          class="text filter-trade-point-button" 
                                          @click="createTradePoint">

                                    <font-awesome-icon icon="plus" />
                                    Создать ТТ
                                </b-button>
                            </b-col>

                            <b-col class="m-0 p-2px">
                                <b-button block 
                                          class="text filter-trade-point-button" 
                                          @click="clearFilter">

                                    <font-awesome-icon icon="trash-alt"/>
                                    Очистить фильтры
                                </b-button>
                            </b-col>

                        </b-row>
                    </b-col>
                </transition>
            </b-row>
           

            <b-row class="filter-trade-point-type">
            
                <b-col v-for="(type, index) in entity.Types"
                       :key="index" 
                       @click="searchByType(type)" 
                       class="p-0 filter-trade-point-type-col">

                    <b-img :src="entity.setImage(type)" />

                    <span class="text filter-trade-point-type-text">{{type.Text}}</span>

                </b-col>
                <b-col>

                    <b-checkbox v-model="filterModel.IsPriceMonitoring"
                                class="admin-checkbox"
                                :value="true"
                                :unchecked-value="false"
                                @change="searchByPM">
                        <span class="text filter-trade-point-type-text">PM</span>
                    </b-checkbox>
                    

                </b-col>

            </b-row>    

        </b-container>

        <b-container v-if="localLoad.Loading">
            <spinner :admin="false" style="margin-top: 50vh;"/>
        </b-container>

        <b-container v-else class="m-0 p-0 view-TT-list">

            <google-map v-if="isViewMap"
                        :start-position="entity.StartPosition"
                        :tradePoints="entity.TradePoints"
                        @dragend="dragend"
                        @select="tradePointSelect"/>

            <list-trade-points v-if="!isViewMap"
                               :tradePoints="entity.TradePoints"
                               @select="tradePointSelect"/>  

        </b-container>

        <employee-trade-point :options="entity.Employees"
                              :is-route="entity.DisplayTT == 2"
                              @apply="getEmployeesTT"/>

    </b-container>

</template>
<script>
import '@/assets/styles/client/tradePoints/tradePoints.css'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import AllRoutes from '@/routes/all.routes'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import AuditTradePointsModel from '@/store/models/client/tradePoints/AuditTradePoints'
import TradePointModel from '@/store/models/client/tradePoints/TradePoint'
import Consts from '@/store/models/consts/clientConsts'

import EmployeeTradePoint from '@/components/client/tradePoints/EmployeeTradePoint'
import ListTradePoints from '@/components/client/tradePoints/ListTradePoints'
import GoogleMap from '@/components/client/tradePoints/GoogleMap'

export default {
    initFilterModel: {
        MaxCount: Consts.TradePointMaxCount,
        Center: {},
        DisplayedTtTypes: [1, 2, 4, 5, 6, 3],
        Employes: [],
        SearchText: null,
        DisplayTts: 4,
        IsPriceMonitoring: false
    },
    data: function() {
        let load = new Loading();
        let localLoad = new Loading();

        let entity = new AuditTradePointsModel();
        
        this.getCenter(load, localLoad);

        return {
            entity: entity,
            auditId: this.$route.query.auditId,

            load: load,
            localLoad: localLoad,
            
            center: null,
            searchText: null,

            isShowSearchInput: false,
            isViewMap: true,

            displayTTs: Consts.DisplayTTs,

            // есть ли Мои маршруты
            isRouteExist: false,
            // есть ли Мои ТТ
            isTradePointsExist: false,

            filterModel: {}
        }
    },
    watch: {
        filterModel: {
            handler: function() {
                this.updateStorage();
            },
            deep: true
        }
    },
    created: function() {

        let storedFilterModel = this.getStorage();
        this.filterModel = {...this.$options.initFilterModel, ...storedFilterModel}; 
        this.entity.IsPriceMonitoring = this.filterModel.IsPriceMonitoring;       
    },
    methods: {
        clearFilter: function() { 

            this.localLoad.Calculate(true);

            this.entity.DisplayTT = 1;
            this.entity.Types.forEach(e => e.Selected = true);
            this.entity.Employees.forEach(e => e.Checked = false);

            this.filterModel = this.entity.createFilterModel(this.searchText);

            this.tradePointFilter();
        },
            
        //---------------- LOCALSTORAGE ----------------------------

        getStorage: function() {
            return JSON.parse(localStorage.getItem('filter.model'));
        },
        setStorage: function(value) {
            localStorage.setItem('filter.model', JSON.stringify(value));
        },
        updateStorage: function() {
            let storedFilterModel = this.getStorage();

            if(!storedFilterModel) storedFilterModel = {};

            storedFilterModel = JSON.parse(JSON.stringify(this.filterModel));
            this.setStorage(storedFilterModel);
        },

        //---------------------------------------------------------

        getCenter: function(load, localLoad) {
            load.Calculate(true);

            apiService.Client.Users.GetCenter()
                .then(response => {
                    this.entity.StartPosition = response.data.Center;
                    this.entity.Branch = response.data.Branch;
                    load.Calculate(false);

                    this.getCheckUser(load, localLoad);
                })
                .catch(error => load.Calculate(false));
        },
        getCheckUser: function(load, localLoad) {
            load.Calculate(true);

            apiService.Client.TradePoints.GetCheckUser()
                .then(response => {
                    this.isRouteExist = response.data.IsRouteExist;
                    this.isTradePointsExist = response.data.IsTradePointsExist;
                    load.Calculate(false);

                    this.getSubordinatesEmployees(load, localLoad);
                })
                .catch(error => load.Calculate(false));
        },
        getSubordinatesEmployees: function(load, localLoad) {
            load.Calculate(true);

            apiService.Client.Users.GetSubordinatesEmployees()
                .then(response => {
                    this.entity.mapFromDto(response.data, this.isRouteExist, this.isTradePointsExist, this.filterModel);
                    load.Calculate(false);
                    
                    localLoad.Calculate(true);
                    this.filterModel = this.entity.createFilterModel(this.searchText);
                    this.tradePointFilter();
                })
                .catch(error => load.Calculate(false));
        },

        tradePointFilter: function() {
            apiService.Client.TradePoints.PostFilter(this.filterModel)
                .then(response => {
                    if(!response.data.length)
                        dialogService.showAlert('Предупреждение', 'По запросу ничего не найдено.');

                    this.entity.TradePoints = response.data.map(e => new TradePointModel().mapFromDto(e, this.center));                        
                    this.localLoad.Calculate(false);
                })
                .catch(error => this.localLoad.Calculate(false));
        },

        openAudit: function() {
            this.$router.push(AllRoutes.Client.Audit.Index + `?id=${this.auditId}`)
        },

        createTradePoint: function() {
            this.$router.push(AllRoutes.Client.TradePoints.Edit + `?auditId=${this.auditId}`);
        },

        tradePointSelect: function(item) {
            this.$router.push(AllRoutes.Client.TradePoints.View + `?id=${item.Id}&auditId=${this.auditId}`);
        },

        hideSearchInput: function() {
            this.isShowSearchInput = !this.isShowSearchInput;
            this.searchText = null;

            this.filterModel = this.entity.createFilterModel(this.searchText);
            this.tradePointFilter();
        },

        clickFilter: function(value) {
                
            if(value == 'Filters') {
                this.$modal.show('employee-tradePoint');
                return;
            }

            this.entity.DisplayTT = this.displayTTs.find(e => e.Text == value).Id;
            
            if(this.entity.isMy()) {
                this.filterModel = this.entity.createFilterModel(this.searchText);

                this.localLoad.Calculate(true);
                this.tradePointFilter();
            }               
        },

        getEmployeesTT: function(value) {                              

            if(!this.entity.Employees.some(e => e.Checked)) {    
                dialogService.showAlert('Предупреждение', 'Выберите сотрудников');
                return;
            }                         

            this.entity.DisplayTT = this.displayTTs.find(e => e.Text == value).Id;
            this.filterModel = this.entity.createFilterModel(this.searchText, this.center);

            this.localLoad.Calculate(true);       
            this.tradePointFilter();                
        },

        setViewMap: function(view) {
            view == 'map' ? this.isViewMap = true : this.isViewMap = false;
        },

        searchByName: function() {
            if(!this.searchText)
                return;

            this.searchTT();
        },

        searchByType: function(value) {
            this.entity.selectType(value);
            this.searchTT();            
        },
        
        searchByPM: function(value) {
          this.entity.IsPriceMonitoring = value;
          this.searchTT();
        },

        searchTT: function() {
            if(this.entity.isEmployees() || this.searchText){
                this.localLoad.Calculate(true);
            }

            this.filterModel = this.entity.createFilterModel(this.searchText, this.center);
            this.tradePointFilter();
        },

        dragend: function(center) {

            this.center = center;

            this.entity.StartPosition = center;
            this.filterModel = this.entity.createFilterModel(this.searchText, center);
            this.tradePointFilter();
        }
    },
    components: {
        Spinner,
        EmployeeTradePoint,
        ListTradePoints,
        GoogleMap
    }
    
}
</script>